import * as React from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Snackbar from "@mui/material/Snackbar";
import RelationsGraph from "../elements/relations-graph";
import { SparqlListingSpecifications } from "../elements/sparql-listing-specifications";
import "./tab.info.less";

export function TabSpecifications({ config, currentUri }: { config: any; currentUri: string }) {
    const [snackbarOpen, setSnackbarOpen] = React.useState(false);
    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(currentUri);
            setSnackbarOpen(true);
        } catch (e) {}
    };
    return (
        <>
            <p className="iri">
                <em>URI:</em>&nbsp;{currentUri}
                <Tooltip title="Copy">
                    <IconButton
                        size="small"
                        type="button"
                        onClick={handleCopy}
                        className="iriCopyButton"
                        style={{ opacity: 0, transition: "opacity 0.2s" }}
                    >
                        <ContentCopyIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={1200}
                    onClose={() => setSnackbarOpen(false)}
                    message="Copied!"
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                />
            </p>
            <SparqlListingSpecifications
                key={currentUri}
                query={config.query}
                queryParameters={[{ name: "term_iri", type: "uri", value: currentUri }]}
            />
            {config.queryWebOfRelations && (
                <RelationsGraph term_iri={currentUri} query={config.queryWebOfRelations} />
            )}
        </>
    );
}
